class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${FacetFiltersForm.wbPfad(searchParams)}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  /* Zwillings-Kategorie (2026-09-29): Bei aktivem Farbfilter die Ergebnisse von «<handle>-alle-farben» holen — dort sind
     die per hide-in-collection ausgeblendeten Farbvarianten enthalten. window.wbZwilling setzt
     sections/main-collection-product-grid.liquid nur, wenn der Zwilling existiert. */
  static wbPfad(searchParams) {
    const z = window.wbZwilling;
    if (!z || window.location.pathname !== z.von) return window.location.pathname;
    return new URLSearchParams(searchParams).has(z.param) ? z.zu : z.von;
  }

  /* Links in der Antwort des Zwillings (Seitenwechsel, Filter entfernen, Formular) wieder auf diese Kategorie zeigen lassen. */
  static wbLinksZurueck(html) {
    const z = window.wbZwilling;
    if (!z || !html) return html;
    return html.split(z.zu + '?').join(z.von + '?').split(z.zu + '"').join(z.von + '"');
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = FacetFiltersForm.wbLinksZurueck(responseText);
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if (typeof changePrice === 'function') {
      changePrice(getStoredPriceOption());
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner',
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter',
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* Zwillings-Kategorie: Wird die Kategorie mit Farbfilter in der Adresse aufgerufen (neu laden, geteilter Link, Seitenwechsel),
   hat der Server sie ohne die ausgeblendeten Farben gerendert — die Karten gleich nach dem Laden aus dem Zwilling ersetzen. */
(function () {
  const start = () => {
    const z = window.wbZwilling;
    if (!z || window.location.pathname !== z.von) return;
    const params = new URLSearchParams(window.location.search);
    if (!params.has(z.param) || typeof FacetFiltersForm === 'undefined') return;
    FacetFiltersForm.renderPage(params.toString(), null, false);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Zusätzliche Farben schon VOR dem ersten Filtern (2026-09-29): Die Farbliste der Kategorie enthält nur Farben ihrer eigenen
   Produkte; Farben, die es nur bei per hide-in-collection ausgeblendeten Varianten gibt, fehlten. Wir holen die Farbwerte des
   Zwillings (templates/collection.wb-farben.liquid) und klonen dafür einen vorhandenen Farbkreis — Aussehen wie gehabt. Wird eine
   ergänzte Farbe gewählt, übernimmt wbPfad() den Zwilling. Nach jedem Neuaufbau der Filter wird erneut ergänzt (idempotent). */
(function () {
  const z = window.wbZwilling;
  if (!z || window.location.pathname !== z.von) return;
  let werte = null;
  let anfrage = null;

  const holen = () => {
    if (anfrage) return anfrage;
    anfrage = fetch(z.zu + '?view=wb-farben', { credentials: 'same-origin', priority: 'low' })
      .then((r) => (r.ok ? r.text() : '[]'))
      .then((t) => { try { werte = JSON.parse(t.trim() || '[]'); } catch (e) { werte = []; } return werte; })
      .catch(() => { anfrage = null; return []; });
    return anfrage;
  };

  /* 2026-10-10 (Nutzer: «hpl weiss ist kaputt beim Filter»): Kachel von bilder.weberbuero.de wie in facets.liquid, Dateiname = Filterwert
     (z. B. «hpl-weiss») statt erstes Wort des Labels («hpl» → fehlt); files.weberbuero.com fehlen u. a. hpl-weiss, fenix-grau/-schwarz. */
  const bildUrl = (wert) => 'https://bilder.weberbuero.de/frontend/images/colors/thumbs/' + String(wert || '').toLowerCase() + '.jpg';
  const anzeigeName = (label) => {
    const l = String(label || '').split('_').join(' ');
    return l.charAt(0).toUpperCase() + l.slice(1);
  };

  const ergaenzen = () => {
    if (!werte || !werte.length) return;
    document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile').forEach((form) => {
      const inputs = form.querySelectorAll('input[name="' + z.param + '"]');
      if (!inputs.length) return;
      const vorhanden = new Set(Array.from(inputs, (i) => i.value));
      const vorlage = inputs[inputs.length - 1].closest('li');
      if (!vorlage) return;
      let nr = 0;
      werte.forEach((w) => {
        if (vorhanden.has(w.value)) return;
        if ((w.value === 'weiß' || w.value === 'Weiß') && (vorhanden.has('weiss') || werte.some((x) => x.value === 'weiss'))) return;
        nr += 1;
        const li = vorlage.cloneNode(true);
        li.setAttribute('data-wb-ergaenzt', '');
        const inp = li.querySelector('input');
        const id = inp.id + '-wb' + nr;
        inp.value = w.value;
        inp.id = id;
        inp.checked = false;
        inp.disabled = false;
        inp.removeAttribute('checked');
        inp.removeAttribute('disabled');
        const lab = li.querySelector('label');
        if (lab) { lab.setAttribute('for', id); lab.classList.remove('facets__label--disabled'); }
        const img = li.querySelector('img');
        if (img) { img.classList.remove('is-fehlt'); img.src = bildUrl(w.value); }
        const tip = li.querySelector('.b-tooltip');
        if (tip) tip.textContent = anzeigeName(w.label);
        const vh = li.querySelector('.visually-hidden');
        if (vh) vh.textContent = anzeigeName(w.label);
        vorlage.parentNode.appendChild(li);
        vorhanden.add(w.value);
      });
    });
  };

  let geplant = false;
  const planen = () => {
    if (geplant) return;
    geplant = true;
    setTimeout(() => { geplant = false; if (werte) ergaenzen(); }, 60);
  };
  const start = () => {
    holen().then(ergaenzen);
    new MutationObserver(planen).observe(document.getElementById('ProductGridContainer')?.closest('.shopify-section') || document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(start, 400));
  else setTimeout(start, 400);
})();

/* Doppelschieberegler für Höhe, Breite, Tiefe (2026-09-29). Shopify kennt als Bereichsfilter nur den Preis — Masse sind
   Listenfilter mit Einzelwerten (mm). Der Regler rastet auf den vorhandenen Werten ein; beim Loslassen (bzw. nach Eingabe in
   ein Zahlenfeld) werden alle Einzelwerte im Bereich angehakt und der normale Filter über das input-Ereignis angestossen.
   Voller Bereich = kein Filter. Werte 0 (keine Angabe) bleiben aussen vor. Die Checkbox-Liste bleibt im DOM (versteckt). */
(function () {
  const PARAMS = ['filter.v.m.plenty.height', 'filter.v.m.plenty.width', 'filter.v.m.plenty.length'];

  const bauen = (form, param) => {
    const inputs = Array.from(form.querySelectorAll('input[type="checkbox"][name="' + param + '"]'));
    if (!inputs.length) return;
    const liste = inputs[0].closest('ul');
    if (!liste) return;
    if (liste.previousElementSibling && liste.previousElementSibling.matches('.wb-mass-regler[data-param="' + param + '"]')) return;
    const nachWert = new Map();
    inputs.forEach((i) => {
      const v = Math.round(parseFloat(i.value));
      if (!(v > 0)) return;
      if (!nachWert.has(v)) nachWert.set(v, []);
      nachWert.get(v).push(i);
    });
    const werte = Array.from(nachWert.keys()).sort((a, b) => a - b);
    if (werte.length < 2) return;
    const n = werte.length - 1;
    const gewaehlt = werte.filter((v) => nachWert.get(v).some((i) => i.checked));
    let lo = gewaehlt.length ? werte.indexOf(gewaehlt[0]) : 0;
    let hi = gewaehlt.length ? werte.indexOf(gewaehlt[gewaehlt.length - 1]) : n;

    const box = document.createElement('div');
    box.className = 'wb-mass-regler';
    box.setAttribute('data-param', param);
    box.innerHTML =
      '<div class="wb-mass-regler__spur"><span class="wb-mass-regler__band"></span>' +
      '<input type="range" min="0" max="' + n + '" step="1" aria-label="Minimum">' +
      '<input type="range" min="0" max="' + n + '" step="1" aria-label="Maximum"></div>' +
      '<div class="wb-mass-regler__felder">' +
      '<label class="wb-mass-regler__feld"><input type="number" inputmode="numeric" aria-label="von"><span>mm</span></label>' +
      '<span class="wb-mass-regler__bis">–</span>' +
      '<label class="wb-mass-regler__feld"><input type="number" inputmode="numeric" aria-label="bis"><span>mm</span></label></div>';
    const [rLo, rHi] = box.querySelectorAll('input[type="range"]');
    const [fLo, fHi] = box.querySelectorAll('input[type="number"]');
    const band = box.querySelector('.wb-mass-regler__band');
    /* Eigene Eingaben dürfen das Filterformular nicht selbst auslösen (facets.js hört auf input am Formular). */
    [rLo, rHi, fLo, fHi].forEach((el) => {
      el.removeAttribute('name');
      el.addEventListener('input', (e) => e.stopPropagation());
      el.addEventListener('change', (e) => e.stopPropagation());
    });

    const zeigen = () => {
      rLo.value = lo; rHi.value = hi;
      fLo.value = werte[lo]; fHi.value = werte[hi];
      band.style.left = (n ? (lo / n) * 100 : 0) + '%';
      band.style.width = (n ? ((hi - lo) / n) * 100 : 100) + '%';
      rLo.style.zIndex = lo > n - 1 ? 3 : 1;
    };
    const naechster = (mm) => {
      let best = 0;
      werte.forEach((v, k) => { if (Math.abs(v - mm) < Math.abs(werte[best] - mm)) best = k; });
      return best;
    };
    const anwenden = () => {
      const voll = lo === 0 && hi === n;
      let geaendert = false;
      werte.forEach((v, k) => {
        const an = !voll && k >= lo && k <= hi;
        nachWert.get(v).forEach((i) => { if (i.checked !== an) { i.checked = an; geaendert = true; } });
      });
      /* Werte 0 (keine Angabe) nie mitfiltern. */
      inputs.forEach((i) => { if (!(Math.round(parseFloat(i.value)) > 0) && i.checked) { i.checked = false; geaendert = true; } });
      if (geaendert) inputs[0].dispatchEvent(new Event('input', { bubbles: true }));
    };

    rLo.addEventListener('input', () => { lo = Math.min(+rLo.value, hi); zeigen(); });
    rHi.addEventListener('input', () => { hi = Math.max(+rHi.value, lo); zeigen(); });
    rLo.addEventListener('change', anwenden);
    rHi.addEventListener('change', anwenden);
    fLo.addEventListener('change', () => { lo = Math.min(naechster(+fLo.value || werte[0]), hi); zeigen(); anwenden(); });
    fHi.addEventListener('change', () => { hi = Math.max(naechster(+fHi.value || werte[n]), lo); zeigen(); anwenden(); });
    [fLo, fHi].forEach((f) => f.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); f.dispatchEvent(new Event('change')); } }));

    liste.setAttribute('data-wb-regler-liste', '');
    /* «+ Mehr anzeigen» steht neben dem fieldset, nicht neben der Liste — im ganzen Filterblock suchen (Nutzer: «soll dann weg»). */
    (liste.closest('details') || liste.parentNode).querySelectorAll('show-more-button').forEach((m) => m.setAttribute('data-wb-regler-liste', ''));
    liste.parentNode.insertBefore(box, liste);
    zeigen();
  };

  const alle = () => {
    document.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile').forEach((form) => PARAMS.forEach((p) => bauen(form, p)));
  };
  let geplant = false;
  const planen = () => { if (geplant) return; geplant = true; setTimeout(() => { geplant = false; alle(); }, 60); };
  const start = () => {
    alle();
    const ziel = document.getElementById('ProductGridContainer')?.closest('.shopify-section') || document.body;
    new MutationObserver(planen).observe(ziel, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* Handy-Filter erst bei Bedarf (2026-09-30): snippets/facets.liquid liefert den Inhalt von #FacetFiltersFormMobile in einem
   <template data-wb-mobile-filter> (inert). Entpackt wird (1) beim Antippen/Öffnen des Filter-Drawers — im Capture-Schritt, also
   vor Dawns onSummaryClick —, (2) im Leerlauf auf kleinen Bildschirmen, damit der Drawer sofort offen ist, und (3) vor jedem
   renderFilters-Durchlauf, sowohl im Dokument als auch im geholten HTML (sonst fände Dawn dort keine mobilen .js-filter und
   renderAdditionalElements griffe ins Leere). Die neuen summary-/button-Elemente werden wie in MenuDrawer.bindEvents verdrahtet,
   aber nur die neuen (kein Doppel-Handler am äusseren summary). Schieberegler und Zusatzfarben oben bauen sich über ihre
   MutationObserver von selbst nach. */
(function () {
  const SEL = '#FacetFiltersFormMobile > template[data-wb-mobile-filter]';
  const entpacken = (root) => {
    const t = root.querySelector(SEL);
    if (!t) return null;
    const form = t.parentNode;
    t.replaceWith(t.content);
    return form;
  };
  const verdrahten = (form) => {
    const drawer = form.closest('menu-drawer');
    if (!drawer || typeof drawer.onSummaryClick !== 'function') return;
    form.querySelectorAll('summary').forEach((s) => s.addEventListener('click', drawer.onSummaryClick.bind(drawer)));
    form
      .querySelectorAll('button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)')
      .forEach((b) => b.addEventListener('click', drawer.onCloseButtonClick.bind(drawer)));
  };
  const live = () => {
    const form = entpacken(document);
    if (form) verdrahten(form);
  };
  if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderFilters === 'function') {
    const original = FacetFiltersForm.renderFilters;
    FacetFiltersForm.renderFilters = function (html, event) {
      /* Dawn übergibt hier den HTML-TEXT (parst erst innen) — dann die Template-Klammer im Text entfernen; bei einem Dokument entpacken. */
      if (typeof html === 'string') {
        html = html.replace('<template data-wb-mobile-filter>', '').replace('</template><!--/wb-mobile-filter-->', '');
      } else if (html && html.querySelector) {
        entpacken(html);
      }
      live();
      return original.call(this, html, event);
    };
  }
  const start = () => {
    const disclosure = document.querySelector('.mobile-facets__wrapper .mobile-facets__disclosure');
    if (!disclosure) return;
    const summary = disclosure.querySelector(':scope > summary');
    if (summary) {
      ['pointerdown', 'touchstart', 'keydown', 'click'].forEach((typ) => summary.addEventListener(typ, live, { capture: true, passive: true }));
    }
    disclosure.addEventListener('toggle', () => { if (disclosure.open) live(); });
    if (window.matchMedia('(max-width: 749px)').matches) {
      const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500));
      idle(() => setTimeout(live, 1500), { timeout: 5000 });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
